import React, { Fragment, useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';
import Header from '../../components/Header/Header.component';
import { RADIO_OPTION_TRAIN_START_DATE, LABELS, LTS_ROUTES_PATH, TOAST_MESSAGE } from '../../constants/LTSConstants';
import { getLTSDateListWithDaysOfRun } from '../../utils/LTSUtils';
import { LTSContext } from '../../context/LTSContext';
import { DateDetails } from '../../types/LTSTypes';
import DatesList from './components/DatesList/DatesList.component';
import HTMLHead from '../../components/HTMLHead/HTMLHead.component';
import '../../../../styles/LTSTrainDate.css';

const LTSTrainDate = (props) => {
  // ---------- props ----------
  const { data } = props;

  // ---------- hooks ----------
  const history = useHistory();

  // ---------- context ----------
  const ltsContext = useContext(LTSContext);
  const { trainDetail, radioValue, daysOfRun, boardingDaysOfRun, setDateDetail, setBoardingDate } = ltsContext;

  useEffect(() => {
    if (!trainDetail?.trainNumber) {
      history.push(LTS_ROUTES_PATH.landingPage);
    }
  }, []);

  // ---------- functions ----------
  const handleOnDateClick = (date: DateDetails) => {
    if (date.valid) {
      if (radioValue === RADIO_OPTION_TRAIN_START_DATE) {
        setDateDetail(date);
      } else {
        setBoardingDate(date);
      }
      history.push(LTS_ROUTES_PATH.landingPage);
    } else {
      toast(TOAST_MESSAGE.trainNotRunningOnDate, {
        id: 'LTSTrainDate-toast'
      });
    }
  };

  // ---------- constants ----------
  const datesList = useMemo(() => {
    return getLTSDateListWithDaysOfRun(radioValue === RADIO_OPTION_TRAIN_START_DATE ? daysOfRun : boardingDaysOfRun);
  }, []);

  // ---------- jsx ----------
  return (
    <Fragment>
      <HTMLHead data={data} blockSearchEngineIndexing />
      <Header
        title={
          radioValue === RADIO_OPTION_TRAIN_START_DATE
            ? LABELS.DATE_PICKER_TRAIN_START_DATE_TITLE
            : LABELS.DATE_PICKER_TRAIN_BOARDING_DATE_TITLE
        }
      />
      <main className="LTSTrainDate-main-wrapper">
        {datesList && datesList?.length > 0 && <DatesList datesList={datesList} onClick={handleOnDateClick} />}
      </main>
    </Fragment>
  );
};

LTSTrainDate.propTypes = {
  data: PropTypes.object
};

export default LTSTrainDate;
